import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import React, { ReactNode } from 'react'

type DialogAlertProps = {
  title: string
  contentText?: string
  content?: ReactNode
  open: boolean
  onSuccess?: () => void
  buttonSuccesText?: string
  onClose?: () => void
  buttonCloseText?: string
}

const DialogAlert: React.FC<DialogAlertProps> = ({
  title,
  contentText,
  content,
  open,
  onSuccess,
  buttonSuccesText,
  onClose,
  buttonCloseText,
}) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby='alert-dialog-title'>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {contentText ? (
          <DialogContentText sx={{ color: 'text.primary' }}>{contentText}</DialogContentText>
        ) : (
          content && <div>{content}</div>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        {onClose && (
          <Button autoFocus onClick={onClose} color='secondary'>
            {buttonCloseText ? buttonCloseText : 'Não'}
          </Button>
        )}
        {onSuccess && (
          <Button onClick={onSuccess} variant='contained' color='secondary'>
            {buttonSuccesText ? buttonSuccesText : 'Sim'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default DialogAlert
